import React from 'react';
import {
  Card as SemanticCard,
  CardContentProps,
  Grid,
  Header,
  Image,
} from 'semantic-ui-react';
import { TileProps } from '../../interfaces/TileProps';
import useBodyClass from '../../hooks/useBodyClass';
import { COMPONENT_BODY_CLASSNAME } from './constants';
import './Tile.less';

export interface Props extends TileProps {
  children: React.ReactNode;
}

export type TileContentProps = CardContentProps;
const TileContent = (props: CardContentProps) => {
  return <SemanticCard.Content className="border-0" {...props} />;
};

export type TileActionProps = CardContentProps;
const TileActions = (props: CardContentProps) => {
  return <SemanticCard.Content extra className="border-0" {...props} />;
};

export const Tile = (props: Props) => {
  useBodyClass(COMPONENT_BODY_CLASSNAME);
  return (
    <>
      <SemanticCard
        fluid={props.fluid ?? true}
        className={props.fluid ? 'card-bg' : 'card-bg-width'}
        link={props.link ?? false}
        onClick={props.onClick}
      >
        {props.headerText && (
          <SemanticCard.Header className="card-header-rectangle">
            <div className="triangle" />
            <span className="card-header-title">{props.headerText}</span>
          </SemanticCard.Header>
        )}
        <SemanticCard.Content className="border-0">
          <Grid centered columns={2}>
            {props.isImageOnly && <Image src={props.imageUrl} />}
            {props.isImageWithText && (
              <Grid.Row centered>
                <Grid.Column>
                  <Header className="logo-text">
                    <Image src={props.imageUrl} />
                    {props.contentText}
                  </Header>
                </Grid.Column>
              </Grid.Row>
            )}
            {props.isTextOnly && (
              <Grid.Row centered className="mt-20 text-center">
                <Header>{props.contentText}</Header>
              </Grid.Row>
            )}
          </Grid>
        </SemanticCard.Content>
        <SemanticCard.Meta className="mt-15">
          <Grid centered columns={2}>
            <span>{props.metaData}</span>
          </Grid>
        </SemanticCard.Meta>
        {props.children}
      </SemanticCard>
    </>
  );
};

Tile.Actions = TileActions;
Tile.Content = TileContent;
